import { render, staticRenderFns } from "./carOwner_mobile.vue?vue&type=template&id=92d2fad8&scoped=true&"
import script from "./carOwner_mobile.vue?vue&type=script&lang=js&"
export * from "./carOwner_mobile.vue?vue&type=script&lang=js&"
import style0 from "./carOwner_mobile.vue?vue&type=style&index=0&id=92d2fad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d2fad8",
  null
  
)

export default component.exports